<template>
  <section class="w-full rounded-none bg-gradient-to-br from-[#E9632C] to-[#F7A62E] py-8 sm:py-12 px-4 sm:px-8 text-white border border-neutral-200">
    <div class="w-full lg:w-3/4 xl:w-2/3 text-left space-y-5">
        <!-- Titel -->
        <h2 class="text-2xl font-extrabold italic uppercase tracking-wide text-white">
          {{ t('materials.promoBadge') }}
        </h2>

        <!-- Lijst -->
      <ul class="space-y-1 text-[20px]">
          <li class="flex items-start gap-1 justify-start">
            <svg class="mt-1 h-5 w-5 text-white shrink-0 mt-0.5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 6L9 17l-5-5 1.5-1.5L9 14l9.5-9.5z" />
            </svg>
            <span>{{ t('marketing.usp1') }}</span>
          </li>
          <li class="flex items-start gap-1 justify-start">
            <svg class="mt-1 h-5 w-5 text-white shrink-0 mt-0.5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 6L9 17l-5-5 1.5-1.5L9 14l9.5-9.5z" />
            </svg>
            <span>{{ t('marketing.usp2') }}</span>
          </li>
          <li class="flex items-start gap-1 justify-start">
            <svg class="mt-1 h-5 w-5 text-white shrink-0 mt-0.5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 6L9 17l-5-5 1.5-1.5L9 14l9.5-9.5z" />
            </svg>
            <span>{{ t('marketing.usp3') }}</span>
          </li>
          <li class="flex items-start gap-1 justify-start">
            <svg class="mt-1 h-5 w-5 text-white shrink-0 mt-0.5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 6L9 17l-5-5 1.5-1.5L9 14l9.5-9.5z" />
            </svg>
            <span>{{ t('marketing.usp4') }}</span>
          </li>
        </ul>

        <!-- Knoppen -->
        <div class="flex flex-col sm:flex-row gap-4 pt-4">
          <a href="/inloggen" class="flex-1 sm:flex-none sm:w-64 bg-black text-white text-xl font-bold italic uppercase py-4 px-8 rounded-none hover:bg-neutral-800 transition text-center md:text-left">
            {{ t('buttons.login') }}
          </a>
          <a href="/registreren" class="flex-1 sm:flex-none sm:w-72 bg-white text-black text-xl font-bold italic uppercase py-4 px-8 rounded-none hover:bg-neutral-100 transition text-center md:text-left">
            {{ t('titles.register') }}
          </a>
        </div>
      </div>
  </section>
</template>

<script setup>
import { t as i18nT } from '../i18n'
const t = (key) => i18nT(key)
</script>
